import { ContainerPage } from '@/components/common'
import { InscriptionProcessForm } from '@/layout/createAccount/InscriptionProcessForm'

export const CreateAccount = (): JSX.Element => {
    return (
        <ContainerPage>
            <InscriptionProcessForm />
        </ContainerPage>
    )
}
